import { useEffect, useState } from "react";
import TanstackDatagrid from "components/ReusableComponents/TanstackDatagrid/TanstackDatagrid";
import { Box, Button, Stack } from "@mui/material";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import FileSaver from "file-saver";
import { AddRounded, Download, DownloadRounded, FilterAltRounded } from "@mui/icons-material";
import CreateOrUpdateFabricModal from "./CreateOrUpdateFabricModal/CreateOrUpdateFabricModal";
import { fabricFinalColumns, weightColumn } from "./data";
import { AuthState } from "context/AuthContext";
import { createdByColumns } from "data/globalData";
import moment from "moment";

// --------- DUMMY DATA (acts like your DB) ----------
const ALL_ROWS = [
	{ id: 1, size: 10, color: "red", sku: "SKU-1" },
	{ id: 2, size: 20, color: "blue", sku: "SKU-2" },
	{ id: 3, size: 30, color: "red", sku: "SKU-3" },
	{ id: 4, size: 40, color: "green", sku: "SKU-4" },
	{ id: 5, size: 50, color: "blue", sku: "SKU-5" },
	{ id: 6, size: 60, color: "red", sku: "SKU-6" },
	{ id: 7, size: 70, color: "green", sku: "SKU-7" },
	{ id: 8, size: 80, color: "blue", sku: "SKU-8" },
	{ id: 9, size: 90, color: "red", sku: "SKU-9" },
	{ id: 10, size: 100, color: "green", sku: "SKU-10" },
];

const FabricMaster = () => {
	const { setLoadingOpen, snackBar, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();
	const [data, setData] = useState([]);
	const [rowCount, setRowCount] = useState(0);
	const [filterObj, setFilterObj] = useState({});
	const [modal, setModal] = useState(false);
	const [modalMode, setModalMode] = useState(false);
	const [selectedRow, setSelectedRow] = useState(false);

	const tableColumns = [...Object.values(fabricFinalColumns), weightColumn, ...createdByColumns].map((row) => ({
		...row,
		align: "center",
		headerAlign: "center",
	}));

	const fetchData = async (limit, offset, filterObj) => {
		const res = await axios.post(`/api/sourcing/fabric_master/get`, {
			limit,
			offset,
			filter: filterObj,
		});
		return res.data.result;
	};

	const handleCreateClick = () => {
		setModal(true);
		setModalMode("create");
	};
	const handleFabricRowSelect = (row) => {
		setModal(true);
		setModalMode("update");
		setSelectedRow(row);
	};
	const handleCreateorEditSave = async (apiBody) => {
		setLoadingOpen(true);
		console.log(apiBody, "sdfhjkjhgfd");
		try {
			if (modalMode === "create") {
				const res = await axios.post("/api/sourcing/fabric_master/create", apiBody);
				setData([res.data.result, ...data]);
				setModal(false);
			} else {
				const res = await axios.put(`/api/sourcing/fabric_master/update/${apiBody?.fabric_code}`, apiBody);
				setData((prev) =>
					prev.map((row) => {
						if (row.fabric_code === apiBody.fabric_code) return { ...apiBody, last_updated_by: user.email };
						return row;
					}),
				);
				setModal(false);
				const stylesUpdated = res.data?.result?.styles_updated;
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					severity: "success",
					message:
						stylesUpdated > 0
							? `Fabric Updated Successfully. ${stylesUpdated} style(s) updated.`
							: `Fabric Updated Successfully`,
				});
				return;
			}
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				severity: "success",
				message: `Fabric ${modalMode === "create" ? "Created" : "Updated"} Successfully`,
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		} finally {
			setLoadingOpen(false);
		}
	};
	const handleDownloadClick = async () => {
		setLoadingOpen(true);
		try {
			await axios({
				url: `/api/sourcing/fabric_master/download_fabric_master`,
				method: "POST",
				responseType: "blob",
				data: { filter: filterObj },
			}).then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `FabricMaster_${moment().format("DD-MMM-yy : HH:SS")}.xlsx`);
				setLoadingOpen(false);
			});
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	return (
		<Box sx={{ height: "calc(100vh - 135px)", p: 1 }} boxSizing="border-box">
			<TanstackDatagrid
				columns={tableColumns}
				pageData={data}
				setPageData={setData}
				rowCount={rowCount}
				setRowCount={setRowCount}
				filterObj={filterObj}
				setFilterObj={setFilterObj}
				// onPageSizeChange={setPageSize}
				// onSortChange={setSort}
				// onColumnFilterChange={setFilters}
				// validateCell={validateCell}
				// onCellEdit={handleCellEdit}
				isLoading={false}
				emptyMessage="No matching records"
				handleRowClick={({ row }) => handleFabricRowSelect(row)}
				getServerSideData={fetchData}
				getRowId={(row) => row[fabricFinalColumns.fabric_code.key]}>
				<Box sx={{ display: "flex", alignItems: "center", p: 1, justifyContent: "space-between" }}>
					<Button variant="contained" size="medium" onClick={handleCreateClick} startIcon={<AddRounded />}>
						Create
					</Button>
					<Button variant="contained" size="small" onClick={handleDownloadClick} startIcon={<DownloadRounded />}>
						Export
					</Button>
				</Box>
			</TanstackDatagrid>
			{modal && (
				<CreateOrUpdateFabricModal
					open={modal}
					setOpen={setModal}
					mode={modalMode}
					handleSaveFunction={handleCreateorEditSave}
					selectedRow={selectedRow}
					setSelectedRow={setSelectedRow}
				/>
			)}
		</Box>
	);
};

export default FabricMaster;
